const defaultName = 'defaultWizard';

function WizardRegistry() {
    /// <summary>
    /// A global registry of wizards which allows them to be retrieved
    /// and controlled from Controllers/Services.
    /// If there is only one wizard, the name parameters are optional.
    /// </summary>
    this.wizards = {};
}

WizardRegistry.prototype.addWizard = function (wizard, name) {
    this.wizards[name || defaultName] = wizard;
};

WizardRegistry.prototype.removeWizard = function (name) {
    delete this.wizards[name || defaultName];
};

WizardRegistry.prototype.getWizard = function (name) {
    return this.wizards[name || defaultName];
};

WizardRegistry.prototype.getWizards = function () {
    return this.wizards;
};

module.exports = WizardRegistry;


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/wizard/wizard-registry-service.js
 **/